<template>
	<TypographyTitle :level="2">
		{{ $t('admin-stats.header') }}
	</TypographyTitle>

	<Table
		:columns="columns"
		:data-source="groupStats"
		:pagination="false"
		:bordered="true"
		:loading="isLoading"
	>
	</Table>
</template>

<script>
import { ref, onMounted } from 'vue';
import { TypographyTitle, Table } from 'ant-design-vue';

import Api from '@/api/Api';
import Consts from '@/api/Consts';

import TranslationUtils from '@/i18n/TranslationUtils';

export default {
	components: {
		TypographyTitle, Table,
	},
	setup() {
		const columns = TranslationUtils.addTranslatedField(
			Consts.ADMIN_STATS_TABLE_COLUMNS,
			'dataIndex', 'title',
			'admin-stats.tableColumns',
		);
		const groupStats = ref([]);
		const isLoading = ref(true);
		const updateStats = () => {
			isLoading.value = true;
			Api.adminMainStatsGet(response => {
				if (response.status === 'ok') {
					groupStats.value = response.stats;
				}
				isLoading.value = false;
			});
		};
		onMounted(updateStats);
		return {
			columns,
			groupStats,
			isLoading,
		};
	},
}
</script>
